export default [
  {
    name: "Übersicht",
    icon: "nc-icon nc-bank",
    path: "/menu"
  },
  {
    name: "Mitglieder",
    icon: "nc-icon nc-book-bookmark",
    badge: "memberAll",
    children: [
      {
        name: "List",
        path: "/mitglieder/list"
      },
      {
        name: "Prüfungen",
        path: "/mitglieder/pruefung",
        badge: "memberReview"
      },
      {
        name: "Support",
        path: "/mitglieder/support",
        badge: "memberSupport"
      },
      {
        name: "Gemeldete Mitglieder",
        path: "/mitglieder/gemeldet",
        badge: "memberReport"
      }
    ]
  },
  {
    name: "Fakes",
    icon: "nc-icon nc-layout-11",
    children: [
      {
        name: "List",
        path: "/fake/list"
      },
      {
        name: "Anlegen",
        path: "/fake/erstellen"
      },
      {
        name: "Online",
        path: "/fake/online",
        hideBuilder: true
      }
    ]
  },
  {
    name: "Moderatoren",
    icon: "nc-icon nc-ruler-pencil",
    badge: "moderatorAll",
    children: [
      {
        name: "List",
        path: "/moderator/list"
      },
      {
        name: "Erstellen",
        path: "/moderator/erstellen"
      },
      {
        name: "Agenturen",
        path: "/agenturen"
      },
      {
        name: "Meldungen an Mod",
        path: "/moderator/meldungen"
      },
      {
        name: "Support",
        path: "/moderator/support",
        badge: "moderatorSupport"
      },
      {
        name: "Abrechnung",
        path: "/moderator/billing"
      },
      {
        name: "Wort Blackliste",
        path: "/blacklist/moderator",
        badge: "blacklistMessage"
      }
    ]
  },
  {
    name: "Zahlungen",
    icon: "nc-icon nc-single-copy-04",
    badge: "memberTransaction",
    children: [
      {
        name: "Vorgänge",
        path: "/zahlungen/vorgaenge",
        badge: "memberTransaction"
      },
      {
        name: "Umsätze",
        path: "/zahlungen/umsaetze"
      },
      {
        name: "Graph",
        path: "/zahlungen/graph"
      },
      {
        name: "Export Zahlungsbelege",
        path: "/export-invoice"
      }
    ]
  },
  {
    name: "Rundmail",
    icon: "nc-icon nc-email-85",
    children: [
      {
        name: "Liste",
        path: "/rundmail/liste"
      },
      {
        name: "Erstellen",
        path: "/rundmail/erstellen"
      }
    ]
  },
  {
    name: "Automatische Nachrichten",
    icon: "nc-icon nc-box",
    children: [
      {
        name: "Liste",
        path: "/automatische-nachrichten/liste"
      },
      {
        name: "Erstellen",
        path: "/automatische-nachrichten/erstellen"
      }
    ]
  },
  {
    name: "Dialogkontrolle",
    icon: "nc-icon nc-chart-bar-32",
    path: "/dialogkontrolle"
  },
  {
    name: "Werbung",
    icon: "nc-icon nc-box",
    children: [
      {
        name: "Liste",
        path: "/werbung/liste"
      },
      {
        name: "Erstellen",
        path: "/werbung/erstellen"
      },
      {
        name: "Eventtracking",
        path: "/werbungsverfolgung/liste"
      }
    ]
  },
  {
    name: "Gutscheine",
    icon: "nc-icon nc-box",
    children: [
      {
        name: "Liste",
        path: "/gutschein/liste"
      },
      {
        name: "Erstellen",
        path: "/gutschein/erstellen"
      }
    ]
  },
  {
    name: "Geschenke",
    icon: "nc-icon nc-layout-11",
    children: [
      {
        name: "Liste",
        path: "/geschenk/liste"
      },
      {
        name: "Erstellen",
        path: "/geschenk/erstellen"
      },
      {
        name: "Kategorien-Liste",
        path: "/geschenkkategorie/liste"
      },
      {
        name: "Kategorie Erstellen",
        path: "/geschenkkategorie/erstellen"
      }
    ]
  },
  {
    name: "Neuigkeiten",
    icon: "nc-icon nc-paper",
    children: [
      {
        name: "Liste",
        path: "/news/liste"
      },
      {
        name: "Erstellen",
        path: "/news/erstellen"
      }
    ]
  },
  // {
  //   name: "Moderation Verlauf",
  //   icon: "nc-icon nc-layout-11",
  //   path: "/moderation"
  // },
  {
    name: "Statistiken",
    icon: "nc-icon nc-single-copy-04",
    children: [
      {
        name: "E-Mail Warteschlange",
        path: "/statistiken/email/warteschlange"
      },
      {
        name: "Logins",
        path: "/statistiken/user-sessions"
      },
      {
        name: "Benutzerinformationen",
        path: "/statistiken/benutzerinformationen"
      },
      {
        name: "Nachrichtenanalyse",
        path: "/statistiken/nachrichtenanalyse"
      },
      {
        name: "E-Mail-Blockierungen",
        path: "/statistiken/email-blockierungen"
      },
      {
        name: "Umgebungsdaten",
        path: "/statistiken/graph"
      },
      {
        name: "E-Mails",
        path: "/statistiken/emails"
      },
      {
        name: "Profilbauer",
        path: "/statistiken/fakes"
      }
    ]
  },
  {
    name: "Einstellungen",
    icon: "nc-icon nc-chart-bar-32",
    children: [
      {
        name: "Allgemein",
        path: "/einstellungen"
      },
      {
        name: "Firmendaten",
        path: "/company-date"
      },
      {
        name: "ASA Liste",
        path: "/asa/liste"
      },
      {
        name: "ASA Erstellen",
        path: "/asa/erstellen"
      },
      {
        name: "Preisstufen-Liste",
        path: "/preisstufe/liste"
      },
      {
        name: "Preisstufe erstellen",
        path: "/preisstufe/erstellen"
      },
      {
        name: "Support-Profile",
        path: `/support/profile/${Laravel.support.id}`
      },
      {
        name: "Support-Vorlagen",
        path: "/support-vorlagen/erstellen"
      },
      {
        name: "Neue Dialoge Einstellung",
        path: "/neueDialogeEinstellung"
      },
      {
        name: "Messengers",
        path: "/messengers"
      }
    ]
  },
  {
    name: "superadmin",
    icon: "nc-icon nc-layout-11",
    children: [
      {
        name: "Dashboard",
        path: "/superadmin/menu"
      },
      {
        name: "System Einstellungen",
        path: "/superadmin/system-settings"
      },
      {
        name: "E-Mail",
        path: "/mail-connection-setting/uebersicht"
      },
      {
        name: "E-Mail Betreffe",
        path: "/mail-subjects/list"
      },
      {
        name: "E-Mail Einstellungen",
        path: "/mail-settings"
      },
      {
        name: "Rundmail Einstellungen",
        path: "/circular-mails-setting"
      },
      {
        name: "Reverifizierung",
        path: "/email-verification-resend"
      },
      {
        name: "Systembenutzer Verwalten",
        path: "/systemuser/list"
      },
      {
        name: "Zahlungsinformation Bearbeiten",
        path: "/paymentsettings"
      },
      {
        name: "Script Injection",
        path: "/script-injection"
      },
      {
        name: "Abmeldelink in Mail",
        path: "/abmeldelink-email"
      },
      {
        name: "Externe Registrierung",
        path: "/externe-registrierung/uebersicht"
      },
      {
        name: "Statische Seiten",
        path: "/footer-pages"
      },
      {
        name: "FAQ Artikel",
        path: "/faq-articles"
      },
      {
        name: "Cache update",
        path: "/cache/update"
      },
      {
        name: "Backups",
        path: "/backups"
      },
      {
        name: "Logging Einstellungen",
        path: "/logging-setting"
      },
      {
        name: "Logout",
        path: "/logout-member"
      },
      {
        name: "Git versionen",
        path: "/git-versions"
      },
      {
        name: "Bildeinstellungen",
        path: "/image-settings"
      },
      {
        name: "Username Blacklist",
        path: "/blacklist/username"
      },
      {
        name: "Layouts",
        path: "/layout"
      },
      {
        name: "Messengers",
        path: "/superadmin/messengers"
      },
      {
        name: "Friendship price",
        path: "/friendship-price"
      },
      {
        name: "Fake Account Settings",
        path: "/superadmin/fake"
      }
    ]
  }
];
